/** Redondeo a céntimos como ROUND(x;2) de Google Sheets: los medios se alejan de cero. */
export function round2(n: number): number {
  // toPrecision(15) quita el error binario (20,365 × 100 = 2036,4999999999998) antes de redondear
  return Math.sign(n) * Math.round(Number((Math.abs(n) * 100).toPrecision(15))) / 100;
}

export function sum(values: Iterable<number>): number {
  let s = 0;
  for (const v of values) s += v;
  return round2(s);
}
